/* eslint-disable react/prop-types */
import React from 'react';
import { Link, useHistory } from 'react-router-dom';

import { connect } from 'react-redux';
import { mapStateToProps, mapDispatchToProps } from '../../../Store';

import { getLoginLink, getRegisterLink, getAccountLink } from '../../../utils/getLinks';

const Welcome = ({ user, config, actions, loading, className = '' }) => {
    const history = useHistory();

    const logoutClick = async (e) => {
        e.preventDefault();
        await actions.userActions.logout();
        history.push('/logout');
    };

    const logInLinks = () => {
        if (user.loggedIn) {
            return (
                <div className='profile-actions'>
                    <a
                        id='logout-btn'
                        className='theme-btn theme-btn-solid-blue text-uppercase mt-0'
                        onClick={logoutClick}
                        role='button'
                        tabIndex={0}
                        onKeyDown={logoutClick}>
                        Log Out Of <br />
                        The Zone
                    </a>
                    <a
                        id='profile-btn'
                        className='theme-btn theme-btn-solid-secondary text-uppercase mt-0'
                        target='_blank'
                        rel='noreferrer'
                        href={getAccountLink(config)}>
                        My Zone
                        <br />
                        Profile
                    </a>
                </div>
            );
        } else {
            return (
                <div className='profile-actions'>
                    <Link id='login-btn' className='theme-btn theme-btn-solid-blue text-uppercase mt-0' to={getLoginLink(config)}>
                        Log in to
                        <br />
                        the Zone
                    </Link>
                    <a
                        id='register-btn'
                        className='theme-btn theme-btn-solid-secondary text-uppercase mt-0'
                        target='_blank'
                        rel='noreferrer'
                        href={getRegisterLink(config)}>
                        Register For <br />A Zone Account
                    </a>
                </div>
            );
        }
    };

    const renderName = () => {
        if (user.loggedIn) {
            return <div>Welcome, {user?.player?.first_name ?? 'Player'}!</div>;
        } else {
            return;
        }
    };

    return (
        <div id='player-name-mask' className={`welcome mx-auto ${className}`}>
            {logInLinks()}
        </div>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(Welcome);
